import { call, select, put, cancelled, takeLatest } from 'redux-saga/effects';
import CONSTANTS from '../CONSTANTS';
import statsService from 'services/statsService';
import { actionStoreKilabPracticeMetricsReducer } from 'store/actions/statsActions';

//Selectors
import { getUser } from 'store/selectors/selectors';

//Helpers
import utilTranslations from '../../helpers/utilTranslations';
import { actionStoreLaborPracticeMetricsReducer } from 'store/actions/statsActions';

let t;

function* sagaGetKilabPracticeMetrics({ keyQuestion, practiceId, doctorAuthId }) {

  const userActive = yield select(getUser);
  t = utilTranslations(userActive.language || 'de', 'laboratory-detail');

  const cancelToken = statsService.getSource();
  try {

    const res = yield call(

      statsService.getKilabPracticeMetrics,
      keyQuestion,
      practiceId,
      doctorAuthId,
      { cancelToken: cancelToken.token }
    );

    if (res.status >= 400) {
      throw new Error("Error getting the study");
    }

    yield put( actionStoreKilabPracticeMetricsReducer( res.data ) );
    
  } catch (error) {

    console.log(error);
    //historyRouter.push("/admin/kilab/index");
  } finally {

    if (yield cancelled()) {

      cancelToken.cancel();
    }
  }
}

function* sagaGetLaborPracticeMetrics({ keyQuestion, practiceId, doctorAuthId }) {

  const userActive = yield select(getUser);
  t = utilTranslations(userActive.language || 'de', 'laboratory-detail');

  const cancelToken = statsService.getSource();
  try {

    const res = yield call(

      statsService.getLaborPracticeMetrics,
      keyQuestion,
      practiceId,
      doctorAuthId,
      { cancelToken: cancelToken.token }
    );

    if (res.status >= 400) {
      throw new Error("Error getting the study");
    }

    yield put( actionStoreLaborPracticeMetricsReducer( res.data ) );
    
  } catch (error) {

    console.log(error);
    //historyRouter.push("/admin/kilab/index");
  } finally {

    if (yield cancelled()) {

      cancelToken.cancel();
    }
  }
}

export function* statsSaga() {

  console.log('*Main Stats Saga');
  yield takeLatest(CONSTANTS.LAB_EARLY_GET_PRACTICE_METRICS, sagaGetKilabPracticeMetrics);
  yield takeLatest(CONSTANTS.LAB_GET_PRACTICE_METRICS, sagaGetLaborPracticeMetrics);
}